export enum SelectType {
  Countries = "Countries",
  Industries = "Industries",
  OrganisationForms = "OrganisationForms",
  Nationalities = "Nationalities",
  CountriesWithChineseRegions = "CountriesWithChineseRegions",
}
